
<template>
  <h1
    v-if='hashtag.length > 0'
    class="hashtag"
  >
    {{hashtag}}
  </h1>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'Hashtag',
  data () {
    return {
      hashtag: '',
    }
  },
  apollo: {
    settings: {
      query: gql`
      query MyQuery {
        settings: settings(where:{key:{_eq:"Hashtag_Live"}}){
          value
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.settings.length > 0) {
            this.hashtag = data.settings[0].value
            console.log(data.settings[0].value)
          }
        }
      },
    },
  },
  mounted () {
    setInterval(() => {
      if (Object.keys(this.$apollo.queries).includes('settings')) {
        this.$apollo.queries.settings.refetch()
      }
    }, 5000)
  },
}
</script>

<style scoped>
.hashtag {
  text-align: right;
  padding-top: 4px;
  padding-right: 20px;
  color: #a38e47;
  font-size: 45px;
  font-family: "Menlo", monospace;
}
</style>
